<div class="video-dialog">
  <div class="dialog-header">
    <div class="header-main">
      <div class="header-icon">
        <mat-icon>play_circle</mat-icon>
      </div>
      <div>
        <h2>Video playback</h2>
        <p>Webinar recording</p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="close-btn"
      (click)="onClose()"
      aria-label="Close video"
      matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="video-stage">
    <video
      #player
      class="video-player"
      controls
      autoplay
      muted
      playsinline
      webkit-playsinline
      preload="metadata"
      [poster]="data.poster || null"
      (error)="onVideoError($event)">
      <source [src]="safeSrc" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</div>
